/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JourneySegment
 */
export interface JourneySegment {
    /**
     * The segment quest (node) this entry places on the canvas.
     * @type {string}
     * @memberof JourneySegment
     */
    questConfigId: string;
    /**
     * 
     * @type {number}
     * @memberof JourneySegment
     */
    x?: number;
    /**
     * 
     * @type {number}
     * @memberof JourneySegment
     */
    y?: number;
}

/**
 * Check if a given object implements the JourneySegment interface.
 */
export function instanceOfJourneySegment(value: object): value is JourneySegment {
    if (!('questConfigId' in value) || value['questConfigId'] === undefined) return false;
    return true;
}

export function JourneySegmentFromJSON(json: any): JourneySegment {
    return JourneySegmentFromJSONTyped(json, false);
}

export function JourneySegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneySegment {
    if (json == null) {
        return json;
    }
    return {
        
        'questConfigId': json['questConfigId'],
        'x': json['x'] == null ? undefined : json['x'],
        'y': json['y'] == null ? undefined : json['y'],
    };
}

export function JourneySegmentToJSON(json: any): JourneySegment {
    return JourneySegmentToJSONTyped(json, false);
}

export function JourneySegmentToJSONTyped(value?: JourneySegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questConfigId': value['questConfigId'],
        'x': value['x'],
        'y': value['y'],
    };
}

